import BookingsBa from './ba/bookings';
import BookingsBg from './bg/bookings';
import BookingsCn from './cn/bookings';
import BookingsTw from './tw/bookings';
import BookingsDe from './de/bookings';
import BookingsDk from './dk/bookings';
import BookingsEn from './en/bookings';
import BookingsEs from './es/bookings';
import BookingsFi from './fi/bookings';
import BookingsFr from './fr/bookings';
import BookingsHr from './hr/bookings';
import BookingsHu from './hu/bookings';
import BookingsGr from './gr/bookings';
import BookingsIt from './it/bookings';
import BookingsJp from './jp/bookings';
import BookingsLt from './lt/bookings';
import BookingsLv from './lv/bookings';
import BookingsMe from './me/bookings';
import BookingsMk from './mk/bookings';
import BookingsMt from './mt/bookings';
import BookingsNl from './nl/bookings';
import BookingsPl from './pl/bookings';
import BookingsPt from './pt/bookings';
import BookingsRs from './rs/bookings';
import BookingsSe from './se/bookings';
import BookingsTr from './tr/bookings';
import BookingsUs from './en-us/bookings';

export default {
    messages: {
        bg: { bookings: BookingsBg },
        cn: { bookings: BookingsCn },
        tw: { bookings: BookingsTw },
        de: { bookings: BookingsDe },
        en: { bookings: BookingsEn },
        'en-us': { bookings: BookingsUs },
        es: { bookings: BookingsEs },
        fi: { bookings: BookingsFi },
        fr: { bookings: BookingsFr },
        hr: { bookings: BookingsHr },
        hu: { bookings: BookingsHu },
        it: { bookings: BookingsIt },
        jp: { bookings: BookingsJp },
        lt: { bookings: BookingsLt },
        lv: { bookings: BookingsLv },
        me: { bookings: BookingsMe },
        mk: { bookings: BookingsMk },
        mx: { bookings: BookingsEs },
        nl: { bookings: BookingsNl },
        pl: { bookings: BookingsPl },
        rs: { bookings: BookingsRs },
        se: { bookings: BookingsSe },
        tr: { bookings: BookingsTr },
    },
};
